import { Observable } from "rxjs";

import st from "lib/utils/index";
import { AccountRepository } from "lib/repositories/index";
import { pushRoute } from "modules/app/actions";
import { createFormInstance } from "modules/utils/index";

export const INITIALIZE_MODEL = "auth/SendResetPasswordInstructionsView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "auth/SendResetPasswordInstructionsView/UPDATE_MODEL";
export const VALIDATE = "auth/SendResetPasswordInstructionsView/VALIDATE";
export const SUBMIT = "auth/SendResetPasswordInstructionsView/SUBMIT";
export const FETCH_SUBMIT_START = "auth/SendResetPasswordInstructionsView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "auth/SendResetPasswordInstructionsView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "auth/SendResetPasswordInstructionsView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.auth.SendResetPasswordInstructionsView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  stateKey: "form",
  successAlertContent: () => I18n.t("papp.auth.SendResetPasswordInstructionsView.success_message"),
  successAlertTimeout: false,
  withFailureAlert: false,
  updateModelAfterSubmit: false,
  mergeFailureAlertIntoErrors: true,
  validate: ({ form: { model } }, errors) => {
    errors.add(`model.email`, st.validators.presence(model.email));
  },
  submitModel: ({
    form: {
      model: { email },
    },
  }) => {
    return AccountRepository.sendResetPasswordInstructions(email);
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,
};

const epics = [...formInstance.epics, (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(pushRoute("/login"))];

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/auth/SendResetPasswordInstructionsView/index.js